module.exports = __webpack_public_path__ + "02ac94ff4f6488a059849adda13802fc.svg";